export function pokerClassName(name) {
  if (name.indexOf('booster') > -1) {
    return '부스터'
  }

  switch (name) {
    case 'goldclass':
      return '골드클래스'

    case '골드클래스':
      return '골드클래스'

    case 'silverclass':
      return '실버클래스'

    case '실버클래스':
      return '실버클래스'

    default:
      return ''
  }
}
